import { render, staticRenderFns } from "./TierUpgradeNoticeBanner.vue?vue&type=template&id=74040405&"
import script from "./TierUpgradeNoticeBanner.vue?vue&type=script&lang=ts&"
export * from "./TierUpgradeNoticeBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports